import axios from "axios";
import { API_URl } from "../..";
import { Metadata } from "../../helpers/metadata";

export const getVariantsByCategorySlug = (slug, page = 1, perPage = 12) => {
  const metadata = {
    pagination: {
      page,
      perPage,
    },
    // sort: {
    //   field: "product.id",
    //   asc: true,
    // },
    // columns: {
    //   "*": [],
    //   default_category_id: [],
    //   product: {
    //     "*": [],
    //     categories: {
    //       "*": [],
    //     },
    //   },
    // },
  };

  if (typeof slug === "string") {
    return axios
      .get(`${API_URl}/variants/category/${slug}`, {
        params: { meta: metadata },
      })
      .then((res) => {
        return {
          entities: res.data.entities,
          total_pages: res.data.meta.pagination.pages,
          total_variants: res.data.meta.pagination.total,
          current_page: res.data.meta.pagination.page,
          per_page: res.data.meta.pagination.perPage,
        };
      })
      .catch((error) =>
        console.log({ context: "variants by  category", error })
      );
  }
};

export const searchVariants = async (search) => {
  const meta = new Metadata();
  meta.filters = { search };

  return await getVariants(meta);
};

export const getVariants = async (meta) => {
  const response = await axios.get(`${API_URl}/variants`, {
    params: { meta },
  });

  return response.data.entities;
};
